import { useMemo } from "react";
import { imageSizeTemplates } from "../../../../ad-assistant/adAssistantDimensions";

const VERTICAL_ASPECT_RATIO = {
  aspectRatio: 0.5625,
  cloudAr: "16:9"
};

const PORTRAIT_ASPECT_RATIO = {
  aspectRatio: 1,
  cloudAr: "1:1"
};

const LANDSCAPE_ASPECT_RATIO = {
  aspectRatio: 1.91,
  cloudAr: "1.91:1"
};

export const useTemplateDimensions = () => {
  return useMemo(() => {
    return {
      PortraitImage: { width: 300, height: 300, ...PORTRAIT_ASPECT_RATIO },
      LandscapeImage: { width: 403, height: 211, ...LANDSCAPE_ASPECT_RATIO },
      VerticalImage: { width: 270, height: 480, ...VERTICAL_ASPECT_RATIO },
      ShapeImage: { width: 270, height: 480, ...VERTICAL_ASPECT_RATIO },
      WaveImage: {
        portrait: {
          width: 300,
          height: 300,
          ...PORTRAIT_ASPECT_RATIO,
          ...imageSizeTemplates.WaveImage.portrait
        },
        landscape: {
          width: 403,
          height: 211,
          ...LANDSCAPE_ASPECT_RATIO,
          ...imageSizeTemplates.WaveImage.landscape
        },
        vertical: {
          width: 270,
          height: 480,
          ...VERTICAL_ASPECT_RATIO,
          ...imageSizeTemplates.WaveImage.vertical
        }
      },
      OneToneImage: {
        portrait: {
          width: 300,
          height: 300,
          ...PORTRAIT_ASPECT_RATIO,
          ...imageSizeTemplates.OneToneImage.portrait
        },
        landscape: {
          width: 403,
          height: 211,
          ...LANDSCAPE_ASPECT_RATIO,
          ...imageSizeTemplates.OneToneImage.landscape
        },
        vertical: {
          width: 270,
          height: 480,
          ...VERTICAL_ASPECT_RATIO,
          ...imageSizeTemplates.OneToneImage.vertical
        }
      },
      DefaultImage: {
        portrait: {
          width: 300,
          height: 300,
          ...PORTRAIT_ASPECT_RATIO,
          ...imageSizeTemplates.DefaultImage.portrait
        },
        landscape: {
          width: 403,
          height: 211,
          ...LANDSCAPE_ASPECT_RATIO,
          ...imageSizeTemplates.DefaultImage.landscape
        },
        vertical: {
          width: 270,
          height: 480,
          ...VERTICAL_ASPECT_RATIO,
          ...imageSizeTemplates.DefaultImage.vertical
        }
      },
      // VIDEOS
      TikTokVideo: {
        width: 270,
        height: 480,
        ...VERTICAL_ASPECT_RATIO,
        videoDimensions: { width: 1080, height: 1920, ...VERTICAL_ASPECT_RATIO }
      },
      PortraitVideo: {
        width: 300,
        height: 300,
        ...PORTRAIT_ASPECT_RATIO,
        videoDimensions: { width: 2000, height: 2000, ...PORTRAIT_ASPECT_RATIO }
      },
      LandscapeVideo: {
        width: 403,
        height: 211,
        ...LANDSCAPE_ASPECT_RATIO,
        videoDimensions: { width: 1952, height: 1022, ...LANDSCAPE_ASPECT_RATIO }
      },
      VerticalVideo: {
        width: 270,
        height: 480,
        ...VERTICAL_ASPECT_RATIO,
        videoDimensions: { width: 1080, height: 1920, ...VERTICAL_ASPECT_RATIO }
      },
      RawVideo: {
        portrait: { width: 300, height: 300, ...PORTRAIT_ASPECT_RATIO },
        landscape: { width: 403, height: 211, ...LANDSCAPE_ASPECT_RATIO },
        vertical: {
          width: 270,
          height: 480,
          ...VERTICAL_ASPECT_RATIO,
          videoDimensions: { width: 1080, height: 1920, ...VERTICAL_ASPECT_RATIO }
        }
      },
      default: { width: 300, height: 300, ...PORTRAIT_ASPECT_RATIO }
    };
  }, []);
};
